__turbopack_context__.v({
  "className": "geist_mono_b5b30860-module__XI5KKq__className",
  "variable": "geist_mono_b5b30860-module__XI5KKq__variable",
});
